import React, { useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

import { ThemeClient } from '../contexts/Theme';
import Navbar from '../Navbar';

import { useHistory } from 'react-router-dom';

import AvatarSelector from '../components/login/AvatarSelector';
import { useAuth } from '../contexts/auth';

import { supabase } from '../supabaseClient';

export default function AvatarPage() {
  const history = useHistory();
  const { user } = useAuth();

  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null);

  const uploadImageToStorage = async () => {
    const { data, error } = await supabase.storage
      .from('avatars')
      .upload(`${user?.id}.png`, selectedImage);

    if (error) {
      console.error('Error uploading image:', error);
    }

  };

  const updateUserAvatar = async (avatarValue) => {
    const { data: updatedUser, error: updateError } = await supabase
      .from('users')
      .update({ avatar: avatarValue })
      .eq('id', user?.id)

    if (updateError) {
      console.error('Error updating user avatar:', updateError);
      return
    }

    console.log('User avatar updated successfully');
  };

  const handleAvatarSelect = (avatar) => {
    setSelectedAvatar(avatar);
  };

  const handleImageSelect = (event) => {
    try {
      setSelectedImage(event.target.files[0]);
    } catch (error) {
      console.error('Error al cargar la imagen:', error);
    }
  };


  const handleSubmit = (event) => {
    event.preventDefault();

    if (selectedImage) {
      uploadImageToStorage();
      updateUserAvatar('url');
    } else {
      updateUserAvatar(JSON.stringify(selectedAvatar));
    }

    history.push('/sessions');
  };

    return (
      <ThemeClient>
        <Navbar title={'Choose your avatar'} />

        <Container component="main" maxWidth="xs">
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            noValidate
            sx={{ mt: 2 }}
          >
            <AvatarSelector onSelectAvatar={handleAvatarSelect} />

            <Box sx={{ mt: 2 }}>
              <Typography variant="h6">Or upload a profile picture</Typography>
              <Button
                variant="contained"
                component="label"
                color="primary"
                sx={{ mt: 1 }}
              >
                Seleccionar archivo
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: 'none' }}
                  onChange={handleImageSelect}
                />
              </Button>
              {selectedImage && (
                <Avatar alt="Selected Image" src={URL.createObjectURL(selectedImage)} sx={{ mt: 1, mb: 2, width: 300, height: 300 }} />
              )}
            </Box>

            <Button
              onClick={handleSubmit}
              sx={{ mt: 3, width: '100%' }}
              variant="contained"
              color="success"
              size="large"
            >
              Elegir
            </Button>
          </Box>
        </Container>
      </ThemeClient>
    );
  }
